<template>
  <div class="post-details">
    <div class="post-details-row heading-3-large">{{ post.details.title }}</div>

    <!--    <div class="post-details-row lead-1-large">-->
    <!--      {{ post.details.description }}-->
    <!--    </div>-->

    <div v-html="post.details.content" class="post-details-row paragraph-1-large"></div>
  </div>
</template>
<script>
import PostInfo from "./PostInfo";

export default {
  name: "PostDetails",
  components: {PostInfo},
  props: {
    post: {
      type: Object,
      required: true
    }
  },
}
</script>
<style lang="scss">
@import "PostDetails";
</style>
